import AssigneesTabsMultiSelect from 'components/inputs/dropdowns/AssigneesTabsMultiSelect/AssigneesTabsMultiSelect';
import { List, OrderedSet, Set } from 'immutable';
import React, { FC } from 'react';
import { ProjectGroup } from 'records/ProjectGroup';
import { Punch } from 'records/Punch';
import './AssigneesStyles.css';

interface Props {
  id: string;
  assigneesOptions: OrderedSet<string>;
  groupAssigneesOptions: List<ProjectGroup>;
  actualPunches: Set<Punch>;
  editable: boolean;
  onChange: (values: OrderedSet<string>, type: AssigneesType) => void;
}

type AssigneesType = 'assignees' | 'groupAssignees';

const MultiplePunchesAssignees: FC<Props> = (props: Props) => {
  const { actualPunches } = props;

  const areAllAssigneesSame = (): boolean => {
    const refSet = actualPunches.first<Punch>().assignees;
    return actualPunches.every((p) => {
      if (refSet.size !== p.assignees.size) return false;
      for (const a of refSet) if (!p.assignees.has(a)) return false;
      return true;
    });
  };

  const areAllGroupsSame = (): boolean => {
    const refSet = actualPunches.first<Punch>().groupAssignees;
    return actualPunches.every((p) => {
      if (refSet.size !== p.groupAssignees.size) return false;
      for (const a of refSet) if (!p.groupAssignees.has(a)) return false;
      return true;
    });
  };

  const getInitialSelectedAssignees = () => {
    if (areAllAssigneesSame() && areAllGroupsSame()) {
      return actualPunches.flatMap((punch) => punch.assignees).toOrderedSet();
    }
    return OrderedSet<string>(['Multiple Assignees']);
  };

  const getInitialSelectedGroups = () => {
    if (areAllAssigneesSame() && areAllGroupsSame()) {
      return actualPunches
        .flatMap((punch) => punch.groupAssignees)
        .toOrderedSet();
    }
    return OrderedSet<string>(['Multiple Groups']);
  };
  const extraProps = {
    getInitialSelectedAssignees,
    getInitialSelectedGroups,
  };

  return <AssigneesTabsMultiSelect {...props} {...extraProps} />;
};

export default MultiplePunchesAssignees;
